import { Link } from "react-router-dom";
import { allCategories, allSpecials } from "@/lib/content";

export default function Footer() {
  return (
    <footer className="relative mt-20 overflow-hidden border-t border-background-300/60 bg-background-100">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-transparent via-primary-950/15 to-accent-950/40" />
      <div className="relative mx-auto w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-[15px] font-extrabold text-background-950">
                亚
              </span>
              <span className="font-heading text-base font-bold tracking-wide text-foreground-50">亚洲无码</span>
            </div>
            <p className="mt-4 max-w-xs text-[13px] leading-relaxed text-foreground-500">
              亚洲无码高清成人影视资料平台，收录日本、韩国、中国香港、中国台湾与泰国等地作品资料，提供分类索引、剧集目录与专题合集浏览。
            </p>
            <div className="mt-4 flex items-center gap-2">
              <span className="flex h-7 items-center rounded border border-accent-500/50 px-2 font-heading text-[10px] font-bold text-accent-300">
                18+
              </span>
              <span className="text-[11px] text-foreground-600">仅限成年人访问</span>
            </div>
          </div>

          <div>
            <h4 className="mb-3 font-heading text-[11px] uppercase tracking-[0.2em] text-foreground-600">
              栏目分类
            </h4>
            <ul className="space-y-2">
              {allCategories.map((category) => (
                <li key={category.key}>
                  <Link
                    to={`/category/${category.key}`}
                    className="cursor-pointer text-[13px] text-foreground-400 transition hover:text-primary-300"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-3 font-heading text-[11px] uppercase tracking-[0.2em] text-foreground-600">
              精选专题
            </h4>
            <ul className="space-y-2">
              {allSpecials.map((special) => (
                <li key={special.id}>
                  <Link
                    to={`/special/${special.id}`}
                    className="cursor-pointer text-[13px] text-foreground-400 transition hover:text-primary-300"
                  >
                    {special.title}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/category/all"
                  className="cursor-pointer text-[13px] text-foreground-400 transition hover:text-primary-300"
                >
                  全部作品
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-3 font-heading text-[11px] uppercase tracking-[0.2em] text-foreground-600">
              使用须知
            </h4>
            <ul className="space-y-2 text-[13px] text-foreground-400">
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5 text-primary-600" />
                <span>本站不提供播放、下载与支付功能</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-file-list-3-line mt-0.5 text-primary-600" />
                <span>剧集目录仅作文字资料展示</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-primary-600" />
                <span className="break-all">contact@asian-archive.example</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-primary-600" />
                <span>内容索引 · 东京 / 首尔 / 香港</span>
              </li>
            </ul>
            <Link
              to="/about"
              className="mt-4 inline-flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300/70 px-3 py-2 text-[12px] text-foreground-300 transition hover:border-primary-600/70 hover:text-primary-300"
            >
              查看完整免责声明
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>

        <div className="mt-10 h-px w-full bg-background-300/60" />

        <div className="mt-5 flex flex-col items-start justify-between gap-3 text-[11px] text-foreground-600 sm:flex-row sm:items-center">
          <p>© 2026 亚洲无码 Asian Uncensored Archive. 演示站点，所有作品与人物均为虚构资料。</p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <Link to="/about" className="cursor-pointer whitespace-nowrap transition hover:text-foreground-300">
              使用条款
            </Link>
            <Link to="/about" className="cursor-pointer whitespace-nowrap transition hover:text-foreground-300">
              隐私说明
            </Link>
            <Link to="/about" className="cursor-pointer whitespace-nowrap transition hover:text-foreground-300">
              内容政策
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}